import * as React from 'react';
import { createPortal } from 'react-dom';

import { useOfferPreviewBalloon } from './hooks/useOfferPreviewBalloon';
import { ISafeAreaInsets } from './utils/getBalloonPosition';
import { EClusterPinAnchor } from '../../../../constants/clusterPins/types';
import { TFeatureWithPrecision } from '../../../../types/map';

export interface IOfferPreviewBalloonProps {
  activeFeature: TFeatureWithPrecision;
  anchor: EClusterPinAnchor;
  children: React.ReactNode;
  map: YMaps.Map;
  onClose(): void;
  previewHeight: number;
  previewWidth: number;
  safeArea: ISafeAreaInsets;
  ymaps: YMaps.IYMaps;
}

export const OfferPreviewBalloon = ({
  activeFeature,
  anchor,
  children,
  map,
  onClose,
  previewHeight,
  previewWidth,
  safeArea,
  ymaps,
}: IOfferPreviewBalloonProps) => {
  const slot = useOfferPreviewBalloon({
    activeFeature,
    anchor,
    map,
    onClose,
    previewHeight,
    previewWidth,
    safeArea,
    ymaps,
  });

  return slot ? createPortal(children, slot) : null;
};

OfferPreviewBalloon.displayName = 'OfferPreviewBalloon';
